import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      data-testid="back-to-top-btn"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      title="Back to top"
      className="fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-[#7DD3FC] text-[#0A0D14] shadow-lg shadow-black/40 flex items-center justify-center hover:bg-[#38BDF8] transition-all hover:-translate-y-0.5 animate-in fade-in slide-in-from-bottom-2 duration-200"
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
}
